import React, { Component } from "react";

import { Card, CardBody, CardTitle, Badge, Button, Row,Col } from "reactstrap";
import { Link } from "react-router-dom";
import { MDBDataTableV5, MDBCol} from 'mdbreact';
import PostApiCall from '../../Api'
import GetApiCall from '../../GETAPI'
import Notiflix from "notiflix";
import moment from 'moment';


class LatestTranaction extends Component {
    constructor(props) {
        super(props);
        this.state = {
          TodayData:[],
          TotalAmount:''
        }
    }


    componentDidMount() {
      Notiflix.Loading.Init({
          svgColor: 'rgb(216, 23, 100)'

      });

      Notiflix.Loading.Dots('');

      GetApiCall.getRequest("Get_Todaycollection").then(resultdes =>
          resultdes.json().then(obj => {

                // console.log(obj.data)

              this.setState({
                  TodayData: obj.data
              })


              Notiflix.Loading.Remove();
          }))

          
         

  }

//   total_amount: 1000
// total_count: 1
    

    render() {
     

        const data = {
          columns: [
            {
                label: 'S.No.',
                field: 'serial',
                sort: 'disabled',
                width: 150
            },
            {
                label: "Account Name",
                field: "name",
                sort: "disabled",
                width: 270
              },
            {
                label: "Book Number",
                field: "accountNumber",
                sort: "disabled",
                width: 270
              },
              {
                label: " Chit Scheme",
                field: "Chitscheme",
                sort: "disabled",
                width: 270
              },
             
             
              {
                label: "Paid Amount",
                field: "paidAmount",
                sort: "disabled",
                width: 100
              },
           
              {
                label: "Payment Mode",
                field: "paymentmode",
                sort: "disabled",
                width: 150
              },
              
            ],
            rows:
            this.state.TodayData.map((data, i) => {
                //  console.log(data)
                return {
                    serial: <td>{(i + 1)}</td>,
                    name: <td>{data.fld_name}</td>,
                    accountNumber: <td>{data.fld_accountno}</td>,
                Chitscheme:<td>{data.fld_chitschema}</td>,
                    paidAmount: <td>{data.fld_chitamount}</td>,
                    paymentmode: <td>{data.fld_clientStatus}</td>,
                  }
            })
    };

          

        return (
            <React.Fragment>
                <Card>
                <div className="maxXchange-bg-soft-pink">
                        <Row>

                       
                            <Col xs="6">
                                <div className="maxXchange-text p-3">
                                    <h5 className="maxXchange-text">Today's Collection</h5>
                                    
                                </div>
                            </Col>
                           
                        </Row>
                    </div>
                
                    <CardBody className="pt-0">
                        <Row>
                            
                        <Col xs="12">
                       
                        <MDBDataTableV5
                        striped
                        bordered
                        small
                        data={data}
                        searchBottom={false}
                        seachTop={true}
                        />

                        </Col>

                         </Row>
                    </CardBody>
                </Card>


            </React.Fragment>
        );
    }
}

export default LatestTranaction;
